// JavaScript Document
const strLink1="https://interior-arne.com/products/"
function setGoods(url,haba,depth,height,color,form){
this.url=url;
this.haba=haba;
this.depth=depth;
this.height=height;
this.color=color;
this.form=form;
}
function searchURL(){
var habaValue=document.getElementById("haba").value;
var depthValue=document.getElementById("depth").value;
var heightValue=document.getElementById("height").value;
var idColor = document.getElementsByName( "colortype" ) ;
for ( colorValue="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  colorValue = idColor[i].id ;
  break ;
 }
}
if(habaValue=="haba-select" && depthValue=="depth-selected" && heightValue=="height-selected"){
alert("「幅・奥行・高さ」を選んでください");
return false;
}
if(habaValue=="haba-select" && depthValue=="depth-selected"){
alert("「幅・奥行」を選んでください");
return false;
}
if(habaValue=="haba-select" && heightValue=="height-selected"){
alert("「幅・高さ」を選んでください");
return false;
}
if(depthValue=="depth-selected" && heightValue=="height-selected"){
alert("「奥行・高さ」を選んでください");
return false;
}
if(habaValue=="haba-select"){
alert("「幅」を選んでください");
return false;
}
if(depthValue=="depth-selected"){
alert("「奥行」を選んでください");
return false;
}
if(heightValue=="height-selected"){
alert("「高さ」を選んでください");
return false;
}
if(colorValue==""){
alert("「カラー」を選んでください");
return false;
}
var url=document.getElementById("link_url");
for(var i in goods){
if(goods[i].haba==habaValue && goods[i].depth==depthValue && goods[i].height==heightValue && goods[i].color==colorValue){
return goods[i].url;
}
}
alert("ご希望サイズ幅"+habaValue+"cm×奥行"+depthValue+"cm×高さ"+heightValue+"cmは購入ページのご用意がございません。\nお手数をおかけしますがお見積りを出しますので当店までお問合せくださいませ。");
return false;
}
function jump(){
var idColor = document.getElementsByName( "colortype" ) ;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  strColor = idColor[i].id ;
  var valueColor = idColor[i].value ;
  break ;
 }
}
var url=searchURL();
if(!url){
return false;
}
window.open(strLink1+url)
return false;
}
goods = new Object();
goods[0] =new setGoods("0000ac002731","60","35","80","wood","normal");
goods[1] =new setGoods("0000ac002738","70","35","80","wood","normal");
goods[2] =new setGoods("0000ac002745","80","35","80","wood","normal");
goods[3] =new setGoods("0000ac002752","90","35","80","wood","normal");
goods[4] =new setGoods("0000ac002759","100","35","80","wood","normal");
goods[5] =new setGoods("0000ac002766","110","35","80","wood","normal");
goods[6] =new setGoods("0000ac002773","120","35","80","wood","normal");
goods[7] =new setGoods("0000ac002780","130","35","80","wood","normal");
goods[8] =new setGoods("0000ac002787","140","35","80","wood","normal");
goods[9] =new setGoods("0000ac002794","150","35","80","wood","normal");
goods[10] =new setGoods("0000ac002801","160","35","80","wood","normal");
goods[11] =new setGoods("0000ac002808","170","35","80","wood","normal");
goods[12] =new setGoods("0000ac002815","180","35","80","wood","normal");
goods[13] =new setGoods("0000ac002822","60","40","80","wood","normal");
goods[14] =new setGoods("0000ac002829","70","40","80","wood","normal");
goods[15] =new setGoods("0000ac002836","80","40","80","wood","normal");
goods[16] =new setGoods("0000ac002843","90","40","80","wood","normal");
goods[17] =new setGoods("0000ac002850","100","40","80","wood","normal");
goods[18] =new setGoods("0000ac002857","110","40","80","wood","normal");
goods[19] =new setGoods("0000ac002864","120","40","80","wood","normal");
goods[20] =new setGoods("0000ac002871","130","40","80","wood","normal");
goods[21] =new setGoods("0000ac002878","140","40","80","wood","normal");
goods[22] =new setGoods("0000ac002885","150","40","80","wood","normal");
goods[23] =new setGoods("0000ac002892","160","40","80","wood","normal");
goods[24] =new setGoods("0000ac002899","170","40","80","wood","normal");
goods[25] =new setGoods("0000ac002906","180","40","80","wood","normal");
goods[26] =new setGoods("0000ac002913","60","45","80","wood","normal");
goods[27] =new setGoods("0000ac002920","70","45","80","wood","normal");
goods[28] =new setGoods("0000ac002927","80","45","80","wood","normal");
goods[29] =new setGoods("0000ac002934","90","45","80","wood","normal");
goods[30] =new setGoods("0000ac002941","100","45","80","wood","normal");
goods[31] =new setGoods("0000ac002948","110","45","80","wood","normal");
goods[32] =new setGoods("0000ac002955","120","45","80","wood","normal");
goods[33] =new setGoods("0000ac002962","130","45","80","wood","normal");
goods[34] =new setGoods("0000ac002969","140","45","80","wood","normal");
goods[35] =new setGoods("0000ac002976","150","45","80","wood","normal");
goods[36] =new setGoods("0000ac002983","160","45","80","wood","normal");
goods[37] =new setGoods("0000ac002990","170","45","80","wood","normal");
goods[38] =new setGoods("0000ac002997","180","45","80","wood","normal");
goods[39] =new setGoods("0000ac003004","60","50","80","wood","normal");
goods[40] =new setGoods("0000ac003011","70","50","80","wood","normal");
goods[41] =new setGoods("0000ac003018","80","50","80","wood","normal");
goods[42] =new setGoods("0000ac003025","90","50","80","wood","normal");
goods[43] =new setGoods("0000ac003032","100","50","80","wood","normal");
goods[44] =new setGoods("0000ac003039","110","50","80","wood","normal");
goods[45] =new setGoods("0000ac003046","120","50","80","wood","normal");
goods[46] =new setGoods("0000ac003053","130","50","80","wood","normal");
goods[47] =new setGoods("0000ac003060","140","50","80","wood","normal");
goods[48] =new setGoods("0000ac003067","150","50","80","wood","normal");
goods[49] =new setGoods("0000ac003074","160","50","80","wood","normal");
goods[50] =new setGoods("0000ac003081","170","50","80","wood","normal");
goods[51] =new setGoods("0000ac003088","180","50","80","wood","normal");
goods[52] =new setGoods("0000ac003095","60","55","80","wood","normal");
goods[53] =new setGoods("0000ac003102","70","55","80","wood","normal");
goods[54] =new setGoods("0000ac003109","80","55","80","wood","normal");
goods[55] =new setGoods("0000ac003116","90","55","80","wood","normal");
goods[56] =new setGoods("0000ac003123","100","55","80","wood","normal");
goods[57] =new setGoods("0000ac003130","110","55","80","wood","normal");
goods[58] =new setGoods("0000ac003137","120","55","80","wood","normal");
goods[59] =new setGoods("0000ac003144","130","55","80","wood","normal");
goods[60] =new setGoods("0000ac003151","140","55","80","wood","normal");
goods[61] =new setGoods("0000ac003158","150","55","80","wood","normal");
goods[62] =new setGoods("0000ac003165","160","55","80","wood","normal");
goods[63] =new setGoods("0000ac003172","170","55","80","wood","normal");
goods[64] =new setGoods("0000ac003179","180","55","80","wood","normal");
goods[65] =new setGoods("0000ac003186","60","60","80","wood","normal");
goods[66] =new setGoods("0000ac003193","70","60","80","wood","normal");
goods[67] =new setGoods("0000ac003200","80","60","80","wood","normal");
goods[68] =new setGoods("0000ac003207","90","60","80","wood","normal");
goods[69] =new setGoods("0000ac003214","100","60","80","wood","normal");
goods[70] =new setGoods("0000ac003221","110","60","80","wood","normal");
goods[71] =new setGoods("0000ac003228","120","60","80","wood","normal");
goods[72] =new setGoods("0000ac003235","130","60","80","wood","normal");
goods[73] =new setGoods("0000ac003242","140","60","80","wood","normal");
goods[74] =new setGoods("0000ac003249","150","60","80","wood","normal");
goods[75] =new setGoods("0000ac003256","160","60","80","wood","normal");
goods[76] =new setGoods("0000ac003263","170","60","80","wood","normal");
goods[77] =new setGoods("0000ac003270","180","60","80","wood","normal");
goods[78] =new setGoods("0000ac003277","60","35","90","wood","normal");
goods[79] =new setGoods("0000ac003284","70","35","90","wood","normal");
goods[80] =new setGoods("0000ac003291","80","35","90","wood","normal");
goods[81] =new setGoods("0000ac003298","90","35","90","wood","normal");
goods[82] =new setGoods("0000ac003305","100","35","90","wood","normal");
goods[83] =new setGoods("0000ac003312","110","35","90","wood","normal");
goods[84] =new setGoods("0000ac003319","120","35","90","wood","normal");
goods[85] =new setGoods("0000ac003326","130","35","90","wood","normal");
goods[86] =new setGoods("0000ac003333","140","35","90","wood","normal");
goods[87] =new setGoods("0000ac003340","150","35","90","wood","normal");
goods[88] =new setGoods("0000ac003347","160","35","90","wood","normal");
goods[89] =new setGoods("0000ac003354","170","35","90","wood","normal");
goods[90] =new setGoods("0000ac003361","180","35","90","wood","normal");
goods[91] =new setGoods("0000ac003368","60","40","90","wood","normal");
goods[92] =new setGoods("0000ac003375","70","40","90","wood","normal");
goods[93] =new setGoods("0000ac003382","80","40","90","wood","normal");
goods[94] =new setGoods("0000ac003389","90","40","90","wood","normal");
goods[95] =new setGoods("0000ac003396","100","40","90","wood","normal");
goods[96] =new setGoods("0000ac003403","110","40","90","wood","normal");
goods[97] =new setGoods("0000ac003410","120","40","90","wood","normal");
goods[98] =new setGoods("0000ac003417","130","40","90","wood","normal");
goods[99] =new setGoods("0000ac003424","140","40","90","wood","normal");
goods[100] =new setGoods("0000ac003431","150","40","90","wood","normal");
goods[101] =new setGoods("0000ac003438","160","40","90","wood","normal");
goods[102] =new setGoods("0000ac003445","170","40","90","wood","normal");
goods[103] =new setGoods("0000ac003452","180","40","90","wood","normal");
goods[104] =new setGoods("0000ac003459","60","45","90","wood","normal");
goods[105] =new setGoods("0000ac003466","70","45","90","wood","normal");
goods[106] =new setGoods("0000ac003473","80","45","90","wood","normal");
goods[107] =new setGoods("0000ac003480","90","45","90","wood","normal");
goods[108] =new setGoods("0000ac003487","100","45","90","wood","normal");
goods[109] =new setGoods("0000ac003494","110","45","90","wood","normal");
goods[110] =new setGoods("0000ac003501","120","45","90","wood","normal");
goods[111] =new setGoods("0000ac003508","130","45","90","wood","normal");
goods[112] =new setGoods("0000ac003515","140","45","90","wood","normal");
goods[113] =new setGoods("0000ac003522","150","45","90","wood","normal");
goods[114] =new setGoods("0000ac003529","160","45","90","wood","normal");
goods[115] =new setGoods("0000ac003536","170","45","90","wood","normal");
goods[116] =new setGoods("0000ac003543","180","45","90","wood","normal");
goods[117] =new setGoods("0000ac003550","60","50","90","wood","normal");
goods[118] =new setGoods("0000ac003557","70","50","90","wood","normal");
goods[119] =new setGoods("0000ac003564","80","50","90","wood","normal");
goods[120] =new setGoods("0000ac003571","90","50","90","wood","normal");
goods[121] =new setGoods("0000ac003578","100","50","90","wood","normal");
goods[122] =new setGoods("0000ac003585","110","50","90","wood","normal");
goods[123] =new setGoods("0000ac003592","120","50","90","wood","normal");
goods[124] =new setGoods("0000ac003599","130","50","90","wood","normal");
goods[125] =new setGoods("0000ac003606","140","50","90","wood","normal");
goods[126] =new setGoods("0000ac003613","150","50","90","wood","normal");
goods[127] =new setGoods("0000ac003620","160","50","90","wood","normal");
goods[128] =new setGoods("0000ac003627","170","50","90","wood","normal");
goods[129] =new setGoods("0000ac003634","180","50","90","wood","normal");
goods[130] =new setGoods("0000ac003641","60","55","90","wood","normal");
goods[131] =new setGoods("0000ac003648","70","55","90","wood","normal");
goods[132] =new setGoods("0000ac003655","80","55","90","wood","normal");
goods[133] =new setGoods("0000ac003662","90","55","90","wood","normal");
goods[134] =new setGoods("0000ac003669","100","55","90","wood","normal");
goods[135] =new setGoods("0000ac003676","110","55","90","wood","normal");
goods[136] =new setGoods("0000ac003683","120","55","90","wood","normal");
goods[137] =new setGoods("0000ac003690","130","55","90","wood","normal");
goods[138] =new setGoods("0000ac003697","140","55","90","wood","normal");
goods[139] =new setGoods("0000ac003704","150","55","90","wood","normal");
goods[140] =new setGoods("0000ac003711","160","55","90","wood","normal");
goods[141] =new setGoods("0000ac003718","170","55","90","wood","normal");
goods[142] =new setGoods("0000ac003725","180","55","90","wood","normal");
goods[143] =new setGoods("0000ac003732","60","60","90","wood","normal");
goods[144] =new setGoods("0000ac003739","70","60","90","wood","normal");
goods[145] =new setGoods("0000ac003746","80","60","90","wood","normal");
goods[146] =new setGoods("0000ac003753","90","60","90","wood","normal");
goods[147] =new setGoods("0000ac003760","100","60","90","wood","normal");
goods[148] =new setGoods("0000ac003767","110","60","90","wood","normal");
goods[149] =new setGoods("0000ac003774","120","60","90","wood","normal");
goods[150] =new setGoods("0000ac003781","130","60","90","wood","normal");
goods[151] =new setGoods("0000ac003788","140","60","90","wood","normal");
goods[152] =new setGoods("0000ac003795","150","60","90","wood","normal");
goods[153] =new setGoods("0000ac003802","160","60","90","wood","normal");
goods[154] =new setGoods("0000ac003809","170","60","90","wood","normal");
goods[155] =new setGoods("0000ac003816","180","60","90","wood","normal");
goods[156] =new setGoods("0000ac003823","60","35","100","wood","normal");
goods[157] =new setGoods("0000ac003830","70","35","100","wood","normal");
goods[158] =new setGoods("0000ac003837","80","35","100","wood","normal");
goods[159] =new setGoods("0000ac003844","90","35","100","wood","normal");
goods[160] =new setGoods("0000ac003851","100","35","100","wood","normal");
goods[161] =new setGoods("0000ac003858","110","35","100","wood","normal");
goods[162] =new setGoods("0000ac003865","120","35","100","wood","normal");
goods[163] =new setGoods("0000ac003872","130","35","100","wood","normal");
goods[164] =new setGoods("0000ac003879","140","35","100","wood","normal");
goods[165] =new setGoods("0000ac003886","150","35","100","wood","normal");
goods[166] =new setGoods("0000ac003893","160","35","100","wood","normal");
goods[167] =new setGoods("0000ac003900","170","35","100","wood","normal");
goods[168] =new setGoods("0000ac003907","180","35","100","wood","normal");
goods[169] =new setGoods("0000ac003914","60","40","100","wood","normal");
goods[170] =new setGoods("0000ac003921","70","40","100","wood","normal");
goods[171] =new setGoods("0000ac003928","80","40","100","wood","normal");
goods[172] =new setGoods("0000ac003935","90","40","100","wood","normal");
goods[173] =new setGoods("0000ac003942","100","40","100","wood","normal");
goods[174] =new setGoods("0000ac003949","110","40","100","wood","normal");
goods[175] =new setGoods("0000ac003956","120","40","100","wood","normal");
goods[176] =new setGoods("0000ac003963","130","40","100","wood","normal");
goods[177] =new setGoods("0000ac003970","140","40","100","wood","normal");
goods[178] =new setGoods("0000ac003977","150","40","100","wood","normal");
goods[179] =new setGoods("0000ac003984","160","40","100","wood","normal");
goods[180] =new setGoods("0000ac003991","170","40","100","wood","normal");
goods[181] =new setGoods("0000ac003998","180","40","100","wood","normal");
goods[182] =new setGoods("0000ac004005","60","45","100","wood","normal");
goods[183] =new setGoods("0000ac004012","70","45","100","wood","normal");
goods[184] =new setGoods("0000ac004019","80","45","100","wood","normal");
goods[185] =new setGoods("0000ac004026","90","45","100","wood","normal");
goods[186] =new setGoods("0000ac004033","100","45","100","wood","normal");
goods[187] =new setGoods("0000ac004040","110","45","100","wood","normal");
goods[188] =new setGoods("0000ac004047","120","45","100","wood","normal");
goods[189] =new setGoods("0000ac004054","130","45","100","wood","normal");
goods[190] =new setGoods("0000ac004061","140","45","100","wood","normal");
goods[191] =new setGoods("0000ac004068","150","45","100","wood","normal");
goods[192] =new setGoods("0000ac004075","160","45","100","wood","normal");
goods[193] =new setGoods("0000ac004082","170","45","100","wood","normal");
goods[194] =new setGoods("0000ac004089","180","45","100","wood","normal");
goods[195] =new setGoods("0000ac004096","60","50","100","wood","normal");
goods[196] =new setGoods("0000ac004103","70","50","100","wood","normal");
goods[197] =new setGoods("0000ac004110","80","50","100","wood","normal");
goods[198] =new setGoods("0000ac004117","90","50","100","wood","normal");
goods[199] =new setGoods("0000ac004124","100","50","100","wood","normal");
goods[200] =new setGoods("0000ac004131","110","50","100","wood","normal");
goods[201] =new setGoods("0000ac004138","120","50","100","wood","normal");
goods[202] =new setGoods("0000ac004145","130","50","100","wood","normal");
goods[203] =new setGoods("0000ac004152","140","50","100","wood","normal");
goods[204] =new setGoods("0000ac004159","150","50","100","wood","normal");
goods[205] =new setGoods("0000ac004166","160","50","100","wood","normal");
goods[206] =new setGoods("0000ac004173","170","50","100","wood","normal");
goods[207] =new setGoods("0000ac004180","180","50","100","wood","normal");
goods[208] =new setGoods("0000ac004187","60","55","100","wood","normal");
goods[209] =new setGoods("0000ac004194","70","55","100","wood","normal");
goods[210] =new setGoods("0000ac004201","80","55","100","wood","normal");
goods[211] =new setGoods("0000ac004208","90","55","100","wood","normal");
goods[212] =new setGoods("0000ac004215","100","55","100","wood","normal");
goods[213] =new setGoods("0000ac004222","110","55","100","wood","normal");
goods[214] =new setGoods("0000ac004229","120","55","100","wood","normal");
goods[215] =new setGoods("0000ac004236","130","55","100","wood","normal");
goods[216] =new setGoods("0000ac004243","140","55","100","wood","normal");
goods[217] =new setGoods("0000ac004250","150","55","100","wood","normal");
goods[218] =new setGoods("0000ac004257","160","55","100","wood","normal");
goods[219] =new setGoods("0000ac004264","170","55","100","wood","normal");
goods[220] =new setGoods("0000ac004271","180","55","100","wood","normal");
goods[221] =new setGoods("0000ac004278","60","60","100","wood","normal");
goods[222] =new setGoods("0000ac004285","70","60","100","wood","normal");
goods[223] =new setGoods("0000ac004292","80","60","100","wood","normal");
goods[224] =new setGoods("0000ac004299","90","60","100","wood","normal");
goods[225] =new setGoods("0000ac004306","100","60","100","wood","normal");
goods[226] =new setGoods("0000ac004313","110","60","100","wood","normal");
goods[227] =new setGoods("0000ac004320","120","60","100","wood","normal");
goods[228] =new setGoods("0000ac004327","130","60","100","wood","normal");
goods[229] =new setGoods("0000ac004334","140","60","100","wood","normal");
goods[230] =new setGoods("0000ac004341","150","60","100","wood","normal");
goods[231] =new setGoods("0000ac004348","160","60","100","wood","normal");
goods[232] =new setGoods("0000ac004355","170","60","100","wood","normal");
goods[233] =new setGoods("0000ac004362","180","60","100","wood","normal");
goods[234] =new setGoods("0000ac004369","60","35","110","wood","normal");
goods[235] =new setGoods("0000ac004376","70","35","110","wood","normal");
goods[236] =new setGoods("0000ac004383","80","35","110","wood","normal");
goods[237] =new setGoods("0000ac004390","90","35","110","wood","normal");
goods[238] =new setGoods("0000ac004397","100","35","110","wood","normal");
goods[239] =new setGoods("0000ac004404","110","35","110","wood","normal");
goods[240] =new setGoods("0000ac004411","120","35","110","wood","normal");
goods[241] =new setGoods("0000ac004418","130","35","110","wood","normal");
goods[242] =new setGoods("0000ac004425","140","35","110","wood","normal");
goods[243] =new setGoods("0000ac004432","150","35","110","wood","normal");
goods[244] =new setGoods("0000ac004439","160","35","110","wood","normal");
goods[245] =new setGoods("0000ac004446","170","35","110","wood","normal");
goods[246] =new setGoods("0000ac004453","180","35","110","wood","normal");
goods[247] =new setGoods("0000ac004460","60","40","110","wood","normal");
goods[248] =new setGoods("0000ac004467","70","40","110","wood","normal");
goods[249] =new setGoods("0000ac004474","80","40","110","wood","normal");
goods[250] =new setGoods("0000ac004481","90","40","110","wood","normal");
goods[251] =new setGoods("0000ac004488","100","40","110","wood","normal");
goods[252] =new setGoods("0000ac004495","110","40","110","wood","normal");
goods[253] =new setGoods("0000ac004502","120","40","110","wood","normal");
goods[254] =new setGoods("0000ac004509","130","40","110","wood","normal");
goods[255] =new setGoods("0000ac004516","140","40","110","wood","normal");
goods[256] =new setGoods("0000ac004523","150","40","110","wood","normal");
goods[257] =new setGoods("0000ac004530","160","40","110","wood","normal");
goods[258] =new setGoods("0000ac004537","170","40","110","wood","normal");
goods[259] =new setGoods("0000ac004544","180","40","110","wood","normal");
goods[260] =new setGoods("0000ac004551","60","45","110","wood","normal");
goods[261] =new setGoods("0000ac004558","70","45","110","wood","normal");
goods[262] =new setGoods("0000ac004565","80","45","110","wood","normal");
goods[263] =new setGoods("0000ac004572","90","45","110","wood","normal");
goods[264] =new setGoods("0000ac004579","100","45","110","wood","normal");
goods[265] =new setGoods("0000ac004586","110","45","110","wood","normal");
goods[266] =new setGoods("0000ac004593","120","45","110","wood","normal");
goods[267] =new setGoods("0000ac004600","130","45","110","wood","normal");
goods[268] =new setGoods("0000ac004607","140","45","110","wood","normal");
goods[269] =new setGoods("0000ac004614","150","45","110","wood","normal");
goods[270] =new setGoods("0000ac004621","160","45","110","wood","normal");
goods[271] =new setGoods("0000ac004628","170","45","110","wood","normal");
goods[272] =new setGoods("0000ac004635","180","45","110","wood","normal");
goods[273] =new setGoods("0000ac004642","60","50","110","wood","normal");
goods[274] =new setGoods("0000ac004649","70","50","110","wood","normal");
goods[275] =new setGoods("0000ac004656","80","50","110","wood","normal");
goods[276] =new setGoods("0000ac004663","90","50","110","wood","normal");
goods[277] =new setGoods("0000ac004670","100","50","110","wood","normal");
goods[278] =new setGoods("0000ac004677","110","50","110","wood","normal");
goods[279] =new setGoods("0000ac004684","120","50","110","wood","normal");
goods[280] =new setGoods("0000ac004691","130","50","110","wood","normal");
goods[281] =new setGoods("0000ac004698","140","50","110","wood","normal");
goods[282] =new setGoods("0000ac004705","150","50","110","wood","normal");
goods[283] =new setGoods("0000ac004712","160","50","110","wood","normal");
goods[284] =new setGoods("0000ac004719","170","50","110","wood","normal");
goods[285] =new setGoods("0000ac004726","180","50","110","wood","normal");
goods[286] =new setGoods("0000ac004733","60","55","110","wood","normal");
goods[287] =new setGoods("0000ac004740","70","55","110","wood","normal");
goods[288] =new setGoods("0000ac004747","80","55","110","wood","normal");
goods[289] =new setGoods("0000ac004754","90","55","110","wood","normal");
goods[290] =new setGoods("0000ac004761","100","55","110","wood","normal");
goods[291] =new setGoods("0000ac004768","110","55","110","wood","normal");
goods[292] =new setGoods("0000ac004775","120","55","110","wood","normal");
goods[293] =new setGoods("0000ac004782","130","55","110","wood","normal");
goods[294] =new setGoods("0000ac004789","140","55","110","wood","normal");
goods[295] =new setGoods("0000ac004796","150","55","110","wood","normal");
goods[296] =new setGoods("0000ac004803","160","55","110","wood","normal");
goods[297] =new setGoods("0000ac004810","170","55","110","wood","normal");
goods[298] =new setGoods("0000ac004817","180","55","110","wood","normal");
goods[299] =new setGoods("0000ac004824","60","60","110","wood","normal");
goods[300] =new setGoods("0000ac004831","70","60","110","wood","normal");
goods[301] =new setGoods("0000ac004838","80","60","110","wood","normal");
goods[302] =new setGoods("0000ac004845","90","60","110","wood","normal");
goods[303] =new setGoods("0000ac004852","100","60","110","wood","normal");
goods[304] =new setGoods("0000ac004859","110","60","110","wood","normal");
goods[305] =new setGoods("0000ac004866","120","60","110","wood","normal");
goods[306] =new setGoods("0000ac004873","130","60","110","wood","normal");
goods[307] =new setGoods("0000ac004880","140","60","110","wood","normal");
goods[308] =new setGoods("0000ac004887","150","60","110","wood","normal");
goods[309] =new setGoods("0000ac004894","160","60","110","wood","normal");
goods[310] =new setGoods("0000ac004901","170","60","110","wood","normal");
goods[311] =new setGoods("0000ac004908","180","60","110","wood","normal");
goods[312] =new setGoods("0000ac004915","60","35","120","wood","normal");
goods[313] =new setGoods("0000ac004922","70","35","120","wood","normal");
goods[314] =new setGoods("0000ac004929","80","35","120","wood","normal");
goods[315] =new setGoods("0000ac004936","90","35","120","wood","normal");
goods[316] =new setGoods("0000ac004943","100","35","120","wood","normal");
goods[317] =new setGoods("0000ac004950","110","35","120","wood","normal");
goods[318] =new setGoods("0000ac004957","120","35","120","wood","normal");
goods[319] =new setGoods("0000ac004964","130","35","120","wood","normal");
goods[320] =new setGoods("0000ac004971","140","35","120","wood","normal");
goods[321] =new setGoods("0000ac004978","150","35","120","wood","normal");
goods[322] =new setGoods("0000ac004985","160","35","120","wood","normal");
goods[323] =new setGoods("0000ac004992","170","35","120","wood","normal");
goods[324] =new setGoods("0000ac004999","180","35","120","wood","normal");
goods[325] =new setGoods("0000ac005006","60","40","120","wood","normal");
goods[326] =new setGoods("0000ac005013","70","40","120","wood","normal");
goods[327] =new setGoods("0000ac005020","80","40","120","wood","normal");
goods[328] =new setGoods("0000ac005027","90","40","120","wood","normal");
goods[329] =new setGoods("0000ac005034","100","40","120","wood","normal");
goods[330] =new setGoods("0000ac005041","110","40","120","wood","normal");
goods[331] =new setGoods("0000ac005048","120","40","120","wood","normal");
goods[332] =new setGoods("0000ac005055","130","40","120","wood","normal");
goods[333] =new setGoods("0000ac005062","140","40","120","wood","normal");
goods[334] =new setGoods("0000ac005069","150","40","120","wood","normal");
goods[335] =new setGoods("0000ac005076","160","40","120","wood","normal");
goods[336] =new setGoods("0000ac005083","170","40","120","wood","normal");
goods[337] =new setGoods("0000ac005090","180","40","120","wood","normal");
goods[338] =new setGoods("0000ac005097","60","45","120","wood","normal");
goods[339] =new setGoods("0000ac005104","70","45","120","wood","normal");
goods[340] =new setGoods("0000ac005111","80","45","120","wood","normal");
goods[341] =new setGoods("0000ac005118","90","45","120","wood","normal");
goods[342] =new setGoods("0000ac005125","100","45","120","wood","normal");
goods[343] =new setGoods("0000ac005132","110","45","120","wood","normal");
goods[344] =new setGoods("0000ac005139","120","45","120","wood","normal");
goods[345] =new setGoods("0000ac005146","130","45","120","wood","normal");
goods[346] =new setGoods("0000ac005153","140","45","120","wood","normal");
goods[347] =new setGoods("0000ac005160","150","45","120","wood","normal");
goods[348] =new setGoods("0000ac005167","160","45","120","wood","normal");
goods[349] =new setGoods("0000ac005174","170","45","120","wood","normal");
goods[350] =new setGoods("0000ac005181","180","45","120","wood","normal");
goods[351] =new setGoods("0000ac005188","60","50","120","wood","normal");
goods[352] =new setGoods("0000ac005195","70","50","120","wood","normal");
goods[353] =new setGoods("0000ac005202","80","50","120","wood","normal");
goods[354] =new setGoods("0000ac005209","90","50","120","wood","normal");
goods[355] =new setGoods("0000ac005216","100","50","120","wood","normal");
goods[356] =new setGoods("0000ac005223","110","50","120","wood","normal");
goods[357] =new setGoods("0000ac005230","120","50","120","wood","normal");
goods[358] =new setGoods("0000ac005237","130","50","120","wood","normal");
goods[359] =new setGoods("0000ac005244","140","50","120","wood","normal");
goods[360] =new setGoods("0000ac005251","150","50","120","wood","normal");
goods[361] =new setGoods("0000ac005258","160","50","120","wood","normal");
goods[362] =new setGoods("0000ac005265","170","50","120","wood","normal");
goods[363] =new setGoods("0000ac005272","180","50","120","wood","normal");
goods[364] =new setGoods("0000ac005279","60","55","120","wood","normal");
goods[365] =new setGoods("0000ac005286","70","55","120","wood","normal");
goods[366] =new setGoods("0000ac005293","80","55","120","wood","normal");
goods[367] =new setGoods("0000ac005300","90","55","120","wood","normal");
goods[368] =new setGoods("0000ac005307","100","55","120","wood","normal");
goods[369] =new setGoods("0000ac005314","110","55","120","wood","normal");
goods[370] =new setGoods("0000ac005321","120","55","120","wood","normal");
goods[371] =new setGoods("0000ac005328","130","55","120","wood","normal");
goods[372] =new setGoods("0000ac005335","140","55","120","wood","normal");
goods[373] =new setGoods("0000ac005342","150","55","120","wood","normal");
goods[374] =new setGoods("0000ac005349","160","55","120","wood","normal");
goods[375] =new setGoods("0000ac005356","170","55","120","wood","normal");
goods[376] =new setGoods("0000ac005363","180","55","120","wood","normal");
goods[377] =new setGoods("0000ac005370","60","60","120","wood","normal");
goods[378] =new setGoods("0000ac005377","70","60","120","wood","normal");
goods[379] =new setGoods("0000ac005384","80","60","120","wood","normal");
goods[380] =new setGoods("0000ac005391","90","60","120","wood","normal");
goods[381] =new setGoods("0000ac005398","100","60","120","wood","normal");
goods[382] =new setGoods("0000ac005405","110","60","120","wood","normal");
goods[383] =new setGoods("0000ac005412","120","60","120","wood","normal");
goods[384] =new setGoods("0000ac005419","130","60","120","wood","normal");
goods[385] =new setGoods("0000ac005426","140","60","120","wood","normal");
goods[386] =new setGoods("0000ac005433","150","60","120","wood","normal");
goods[387] =new setGoods("0000ac005440","160","60","120","wood","normal");
goods[388] =new setGoods("0000ac005447","170","60","120","wood","normal");
goods[389] =new setGoods("0000ac005454","180","60","120","wood","normal");

